//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.CollisionShapeBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Category",1,0],[0,"CollisionFactor",1,0],[0,"CollisionMaterial",1,"Mechatronics.CollisionMaterial",0],[0,"CollisionProperties",1,0],[0,"CollisionShape",1,0],[1,"Geometry",0,"SelectNXObjectList",0],[0,"HighlightOnCollision",1,0],[0,"Name",1,0],[1,"Offset",0,"Expression",0],[0,"PauseOnceCollide",1,0],[0,"StickCollision",1,0],[0,"Thickness",1,0]],[[["geometries"],"SetGeometry",{},1,0],[[],"CalculateConvex",{},0,0],[[],"CalculateMesh",{},0,0],[[],"CalculateMultiConvex",{},0,0],[[],"CalculateHole",{},0,0],[[],"CalculateUserDefinedConvex",{},0,0],[[],"ExecuteCollisionSection",{},0,0],[[],"GetCsao",{R_:{casoTag:"GeometricAnalysis.SectionAnalysis.SectionAnalysisExObject"}},0,0],[["csaoTag"],"SetCsao",{},1,0],[["solidTag"],"GetFacetFromSolid",{R_:{facetTag:"NXObject"}},1,0],[[],"DeleteTempFacetsAndHideCsao",{},0,0]],[]];
SPLM.Mechatronics.CollisionBodyBuilder = class extends SPLM.Mechatronics.CollisionShapeBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.CollisionBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.CollisionBodyBuilder.CollisionShapeTypes = Object.freeze({
    "Box" : "Box", "Sphere" : "Sphere", "Cylinder" : "Cylinder", "Capsule" : "Capsule", "Convex" : "Convex", "MultiConvex" : "MultiConvex", "Hole" : "Hole", "Mesh" : "Mesh", "UserDefinedConvex" : "UserDefinedConvex"});

SPLM.Mechatronics.CollisionBodyBuilder.ShapePropertyTypes = Object.freeze({
    "Automatic" : "Automatic", "UserDefined" : "UserDefined"});

export default SPLM;